<div class="search">
  <div class="input-container">
    <mat-icon class="icon-sidebar" svgIcon="bueno-search"></mat-icon>
    <input
      type="text"
      [(ngModel)]="searchQuery"
      (ngModelChange)="onSearchQueryChange($event)"
      [placeholder]="'SEARCH_ROUTE_PLACEHOLDER' | translate"
      (focus)="isPanelOpen = true"
      (blur)="onInputBlur()"
      (keydown)="onKeyDown($event)"
      #searchInput />
    @if (searchQuery) {
    <button class="clear-button" type="button" (click)="clearSearch()" [attr.aria-label]="'Clear search' | translate">
      <ng-icon name="heroXMark"></ng-icon>
    </button>
    }
  </div>

  @if (isPanelOpen && filteredRoutes.length > 0) {
  <div class="custom-dropdown">
    @for (route of filteredRoutes; track route; let i = $index) {
    <div
      class="dropdown-option"
      [class.highlighted]="highlightedIndex === i"
      (click)="onOptionSelected(route)"
      (mouseenter)="highlightedIndex = i">
      <div class="option-content">
        @if (route.icon) {
        <ng-icon [name]="route.icon"></ng-icon>
        }
        <span>{{route.displayName}}</span>
      </div>
    </div>
    }
  </div>
  }
</div>
